import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { CharterStatus } from '../../redux/types/charterTypes'

interface CharterStatusBadgeProps {
  status: CharterStatus | string | null | undefined
  className?: string
}

const STATUS_CONFIG: Record<
  string,
  { label: string; className: string }
> = {
  not_started: {
    label: 'Not Started',
    className: 'bg-gray-100 text-gray-600 border-gray-200',
  },
  in_progress: {
    label: 'In Progress',
    className: 'bg-blue-100 text-blue-700 border-blue-200',
  },
  completed: {
    label: 'Completed',
    className: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  },
  locked: {
    label: 'Ratified',
    className: 'bg-violet-100 text-violet-700 border-violet-200',
  },
  renegotiating: {
    label: 'Re-negotiating',
    className: 'bg-amber-100 text-amber-700 border-amber-200',
  },
}

export function CharterStatusBadge({ status, className }: CharterStatusBadgeProps) {
  const config = STATUS_CONFIG[status ?? ''] ?? {
    label: status ?? 'Unknown',
    className: 'bg-gray-100 text-gray-500 border-gray-200',
  }

  return (
    <Badge variant='outline' className={cn(config.className, className)}>
      {config.label}
    </Badge>
  )
}
